import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import { Tabs } from "components";
import "modules/LocationOverviewDashboard/components/LocationOverviewHeader/LocationOverviewHeader.scss";

import type { TabData } from "components";

type LocationOverviewHeaderProps = {
  isUpdateLocationPending: boolean;
};

export const LocationOverviewHeader = ({ isUpdateLocationPending }: LocationOverviewHeaderProps) => {
  const { t } = useTranslation();

  const tabs: Map<string, TabData> = useMemo(
    () =>
      new Map([
        ["general", { data: [], id: "general", title: t("v8_general", "General"), icon: <Icon className="gears" /> }],
        ["workorder", { data: [], id: "workorder", title: t("v8_workorder", "Workorder"), icon: <Icon className="eye" /> }],
        ["keylabelKeylocker", { data: [], id: "keylabelKeylocker", title: t("v8_keylabel_keylocker", "Keylabel & Keylocker"), icon: <Icon className="key" /> }],
        ["dmsSystem", { data: [], id: "dmsSystem", title: t("v8_dms_system", "DMS / System"), icon: <Icon className="cloud" /> }],
        ["service", { data: [], id: "service", title: t("v8_service", "Service"), icon: <Icon className="wrench" /> }],
        ["tyres", { data: [], id: "tyres", title: t("v8_tyres", "Tyres"), icon: <Icon className="tire" /> }],
        ["statuses", { data: [], id: "statuses", title: t("v8_statuses", "Statuses"), icon: <Icon className="thumbtack" /> }]
      ]),
    []
  );

  return (
    <div className="LocationOverviewHeader">
      <div className="row center">
        <div className="full tabs">
          <Tabs data={tabs} />
        </div>
        <div className="save">
          <Button color="green" type="submit" disabled={isUpdateLocationPending} loading={isUpdateLocationPending}>
            {t("v8_save", "Save")}
            <Icon className="check" />
          </Button>
        </div>
      </div>
    </div>
  );
};
